/**
 * Container statuses as an enum
 * TODO: Hoist this to a higher types level once it's needed elsewhere
 */
export enum Status {
  OnVessel = 'on_vessel',
  Arrived = 'arrived',
  GatedOut = 'gated_out',
  Terminated = 'terminated',
  NotFound = 'not_found',
}

export interface StatusFilter {
  type: Status;
  label: string;
  searchParams: Record<string, string[]>;
  filterCountKey: string;
}

export const STATUS_FILTERS: StatusFilter[] = [
  {
    type: Status.OnVessel,
    label: 'On Vessel',
    filterCountKey: 'OnVessel',
    searchParams: { importStatus: ['vessel'] },
  },
  {
    type: Status.Arrived,
    label: 'Arrived',
    filterCountKey: 'Import',

    searchParams: { importStatus: ['yard', 'rail', 'unknown'] },
  },
  {
    type: Status.GatedOut,
    label: 'Gated Out',
    filterCountKey: 'GatedOut',
    searchParams: { containerStatus: ['gated_out'] },
  },
  {
    type: Status.Terminated,
    label: 'Terminated',
    filterCountKey: 'Terminated',
    searchParams: { containerStatus: ['terminated'] },
  },
  {
    type: Status.NotFound,
    label: 'Not found yet',
    filterCountKey: 'NotFound',
    searchParams: { containerStatus: ['not_found'] },
  },
];
